/* Preview which aims to be similar to the resulting PDF. */
// noinspection JSUnusedGlobalSymbols
export default function () {
    $(window).on('load', function () {
        const $previewContainer = $('#content');
        $previewContainer.addClass('pdf-preview-container'); // Distinction for preview and actual PDF

        setTimeout(function () {
            addPageBreaks($previewContainer);
            emulateMinPageHeight($previewContainer);
        }, 200); // Use timeout in order to make sure the page is already fully rendered

        /**
         * Find elements with page-break CSS settings and add page-break HTML elements for those.
         *
         * @param $previewContainer
         */
        function addPageBreaks($previewContainer: JQuery): void {
            const $subElements = $('*', $previewContainer);

            // Add page-breaks before
            $subElements.filter(function () {
                    return $(this).css('page-break-before') == 'always' && !$(this).hasClass('page-break');
                }
            ).before(
                $('<div></div>').addClass('page-break')
            )

            // Add page-breaks after
            $subElements.filter(function () {
                    return $(this).css('page-break-after') == 'always' && !$(this).hasClass('page-break');
                }
            ).after(
                $('<div></div>').addClass('page-break')
            )
        }

        /**
         * For each page break make sure the correspondig page has a minimum height (by adding more margin to the page-break HTML element) in order to emulate the minimum of an actual page size.
         *
         * @param $previewContainer
         */
        function emulateMinPageHeight($previewContainer: JQuery): void {
            const pageHeight = parseInt($previewContainer.css('min-height')) + parseInt($previewContainer.css('padding-top')) + parseInt($previewContainer.css('padding-bottom'));

            let $previousPageBreakElement: JQuery = null;

            // Handle page breaks
            $('.page-break').each(function () {
                if ($previousPageBreakElement === null) {
                    $previousPageBreakElement = $previewContainer;
                }
                const minOffsetTop = $previousPageBreakElement.offset().top + pageHeight;
                const currentOffsetTop = $(this).offset().top;
                if (currentOffsetTop < minOffsetTop) {
                    $(this).css('margin-top', '+=' + (minOffsetTop - currentOffsetTop));
                }
                $previousPageBreakElement = $(this);
            });

            // Handle last page
            if ($previousPageBreakElement !== null) {
                const $lastElement: JQuery = $previewContainer.children().last();
                const minOffsetBottom = $previousPageBreakElement.offset().top + $previousPageBreakElement.outerHeight() + pageHeight;
                const currentOffsetBottom = $lastElement.offset().top + $lastElement.outerHeight();
                if (currentOffsetBottom < minOffsetBottom) {
                    $lastElement.css('margin-bottom', '+=' + (minOffsetBottom - currentOffsetBottom));
                }
            }
        }
    });
}